import React from "react";
import "./LeadershipFounderMessage.css";
import founderPhoto from "../../Assets/leadership/leaderfounder.png";
import vcnrLogo from "../../Assets/vcnr-logo-white.png";

const LeadershipFounder = () => {
  return (
    <section className="Leaderfounder-section">
      <div className="Leaderfounder-container">
        <div className="Leaderfounder-left">
          <div className="Leaderfounder-image-wrapper">
            <img src={founderPhoto} alt="Founder" className="Leaderfounder-image" />
          </div>
        </div>
        <div className="Leaderfounder-right">
          <h2 className="Leaderfounder-heading">Foundation &  <br />CSR Leader</h2>
          <img src={vcnrLogo} alt="VCNR Logo" className="Leadervcnr-logo" />
          <h4 className="Leaderfounder-name">
            Mr. Ramaswamy V <br />Managing Trustee,  <br /> Hitachinthana Charitable Trust
          </h4>
          <p className="Leaderfounder-text">
Mr. Ramaswamy believes real progress starts when everyone gets a fair chance. the foundation’s initiatives in rural schooling, healthcare, and empowerment programs.          </p>
          <p className="Leaderfounder-text">
We didn’t just build businesses, we built bridges of opportunities.
          </p>
          <button className="explore-btn">Read His Story in Unstoppable</button>
        </div>
      </div>
    </section>
  );
};

export default LeadershipFounder;
